import React, { memo } from 'react'

/**
 * One unit of the composition: the unit icon on the military background, with the
 * total amount produced during the game.
 * side mirrors the count to the outer edge, same as the landmark column.
 */
const UnitDisplay = memo(({ unit, side = 'left', className = '' }) => {
	if (!unit) return null

	return (
		<div className={`unitComp__item unitComp__item--${side} ${className}`.trim()}>
			<div className="unitComp__iconBox" style={{ backgroundImage: `url(/liveGameIcons/military_background.png)` }}>
				<img className="unitComp__icon" src={unit.icon ?? '/liveGameIcons/unknown.png'} alt={unit.name} />
			</div>
			<div className="unitComp__count">{unit.count}</div>
		</div>
	)
})

export { UnitDisplay }
